// @flow
import React from 'react';
import { bind } from '@ta/common.api';
import { localize } from '@ta/common.i18n';
import InboxTriggerProvider from './InboxTriggerProvider';
import styles from './InboxTrigger.less';

/**
 * A global nav action button that opens the inbox overlay
 */
const InboxTrigger = () => (
  <InboxTriggerProvider>
    {({ ref, onClick, hasUnreadConvos }) => (
      <div
        title={localize('inbox_title') /* Inbox */}
        className={styles.container}
        onClick={onClick}
        ref={ref}
      >
        <div className={`${styles.inboxIcon} ui_icon comments`}>
          <div className={styles.label}>{localize('inbox_title')}</div>
        </div>

        {hasUnreadConvos && <div className={`ui_jewel ${styles.jewel}`} />}
      </div>
    )}
  </InboxTriggerProvider>
);

export default bind<{||}, {||}, _, _, _, _>((state, stage) => {
  InboxTriggerProvider.stage(state, stage);
  return () => ({});
})(InboxTrigger);

export { InboxTriggerProvider };
